// @flow
import request from 'mz-sdk/client/request'
import objectToQueryString from 'mz-utils/objectToQueryString'
import buildParkingSpotSuggestion from './builders/buildParkingSpotSuggestion'

// Types
import type { SuggestionLocation } from '../../models/location'

export type ExtendedSuggestionLocation = {
  ...SuggestionLocation,
  spot_id: string,
  spot_source: string,
}

export type TravelCarParkingSpot = {
  id: string,
  source: string,
  name: string,
  latitude: number,
  longitude: number,
  radius: {
    value: number,
    unit: 'km',
  },
  country: string,
}

// Constants
export const TRAVEL_CAR_SPOTS_ENDPOINT = 'https://www.travelcar.com/api/spots/'

/**
 * Get a parking spot from travelCar details.
 * @param  {string} place String
 * @return @return {Promise|Error} A resolved Promise with place details or Rejected with an Error.
 */
export const getParkingSpotSuggestions = (
  query: string
): Promise<Array<ExtendedSuggestionLocation>> =>
  request
    .get(`${TRAVEL_CAR_SPOTS_ENDPOINT}${objectToQueryString({ query })}`)
    .then((response: Array<TravelCarParkingSpot>) =>
      response.map((spot) => buildParkingSpotSuggestion(spot))
    )

export default getParkingSpotSuggestions
